const FormTools = {};

FormTools.install = function (Vue) {

    function flattenPage(page) {
        return flattenItems(activatedItems(page));
    }

    function flattenItems(items) {
        let data = new Map();
        for (let item of items) {
            if (item.type === 8)
            {
                if (item.value && item.value.length > 0)
                {
                    data.set(item.identifier, item.value.map(v => v.id))
                }
            }
            else
            {
                data.set(item.identifier, item.value);
            }
        }
        return data;
    }

    // Recursively search the form for all items with matching identifier
    function findItemsByIdentifier(formObj, identifier, results = [])
    {
        // Base case: form is not defined or not an object
        if (!formObj || typeof formObj !== 'object') return results;

        // Check if form is an array
        if (Array.isArray(formObj))
        {
            // Search each element in the array
            for (const item of formObj)
            {
                findItemsByIdentifier(item, identifier, results);
            }
        }
        else
        {
            // Check if current object has the identifier
            if (formObj.identifier === identifier)
            {
                results.push(formObj);
            }

            // Check pages
            if (formObj.pages)
            {
                for (const page of formObj.pages)
                {
                    findItemsByIdentifier(page, identifier, results);
                }
            }

            // Check items
            if (formObj.items)
            {
                for (const item of formObj.items)
                {
                    findItemsByIdentifier(item, identifier, results);
                }
            }

            // Check activators
            if (formObj.activators)
            {
                for (const key in formObj.activators)
                {
                    if (formObj.activators.hasOwnProperty(key))
                    {
                        findItemsByIdentifier(formObj.activators[key], identifier, results);
                    }
                }
            }
        }

        // Return all found items
        return results;
    }

    function activatedItems(page, form = false)
    {
        let items = Array();

        for (let item of page.items)
        {

            for (let [index,activatedItem] of activatedItemsForItem(item).entries())
            {

                if (activatedItem.pageId === null || activatedItem.pageId === 0 || activatedItem.pageId === page.id || !page.original)
                {
                    // No element with this ID in the DOM, safe to push
                    items.push(activatedItem);
                }
            }
        }
        return items;
    }

    function activatedItemsForItem(item)
    {
        let items = [];
        items.push(item);

        if (!isEmptyObject(item.activators))
        {
            for (let activatorKey in item.activators)
            {
                const isTriggered = Array.isArray(item.value)
                    ? item.value.includes(activatorKey)
                    : activatorKey === item.value;
                if (Object.prototype.hasOwnProperty.call(item.activators, activatorKey) && isTriggered)
                {
                    let activatedItems = item.activators[activatorKey];
                    for (let activatedItem of activatedItems)
                    {
                        for (let subItem of activatedItemsForItem(activatedItem))
                        {
                            items.push(subItem);
                        }
                    }
                }
                else if (Object.prototype.hasOwnProperty.call(item.activators, activatorKey))
                {
                    for (let inactiveItem of item.activators[activatorKey])
                    {
                        clearItemAndDescendants(inactiveItem);
                    }
                }
            }
        }
        return items;
    }

    function clearItemAndDescendants(item)
    {
        item.value = Array.isArray(item.value)
            ? []
            : item.type === 7 ? "0" : "";

        Object.values(item.activators || {}).forEach(items =>
            items.forEach(clearItemAndDescendants)
        );
    }

    function mergeMaps(map1, map2) {
        let merged = new Map();
        map1.forEach((v, k) => merged.set(k, v));
        map2.forEach((v, k) => merged.set(k, v));
        return merged;
    }

    function isEmptyObject(obj) {
        for(let prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return false;
            }
        }
        return true;
    }

    Vue.prototype.$formTools = {};

    Vue.prototype.$formTools.validate = (form) => {
        let pages = form.pages;
        let validated = true;
        let failed_field = null;

        let data = Vue.prototype.$formTools.flatten(form);
        const obj = Vue.prototype.$formTools.mapToJson(data);

        let identifier = form.identifier === 'diary' ? 'Field222' : 'Field4';

        if (form.identifier === "supervision")
        {
            validated = true;
            failed_field = null;
            return [validated,failed_field];
        }
        else if(form.identifier !== "supervision" && !obj[identifier].trim().length || !obj[identifier].trim().length)
        {
            validated = false;
            failed_field = 'Title';
            return [validated,failed_field];
        }

        return [validated,failed_field];

        for (let page of pages)
        {
            if(!page.subPages)
            {
                for(let item of page.items)
                {
                    if(validated && item.required && item.value === "")
                    {
                        validated = false;
                        failed_field = item.title;
                    }
                }
            }
            else
            {
                let sub_pages = [];

                for(let sub_page of page.subPages)
                {
                    for(let item of sub_page.items)
                    {
                        if(validated && item.required && item.value === "")
                        {
                            validated = false;
                            failed_field = item.title;
                        }
                    }
                }
            }

        }

        return [validated,failed_field];
    }

    /**
     * Set the value of the first form item matching the given identifier. 
     * Returns true if successful, false if not (e.g. no matching item found).
     * 
     * @param {*} form 
     * @param {*} identifier 
     * @param {*} value 
     * @returns {boolean}
     */
    Vue.prototype.$formTools.setItemValue = (form, identifier, value) => {
        if (!form || !identifier) {
            return false;
        }

        const items = findItemsByIdentifier(form, identifier);
        if (!items.length) {
            return false;
        }

        items[0].value = value ?? "";
        return true;
    }

    Vue.prototype.$formTools.getItemValue = (form, identifier) => {
        if (!form || !identifier) {
            return "";
        }

        const items = findItemsByIdentifier(form, identifier);
        if (!items.length) {
            return "";
        }

        return items[0].value ?? "";
    }

    Vue.prototype.$formTools.flatten = (form) => {
        let pages = form.pages;
        let data = new Map();
        for (let page of pages)
        {

            if(!page.subPages)
            {
                data = mergeMaps(data, flattenPage(page));
            }
            else
            {
                let sub_pages = [];

                for(let sub_page of page.subPages)
                {
                   let activated_items = activatedItems(sub_page);
                   let flattened_sub_page = flattenItems(activated_items);
                   sub_pages.push(flattened_sub_page);
                }

                data = mergeMaps(data, new Map().set(page.title,sub_pages));
            }

        }
        return data;
    };

    Vue.prototype.$formTools.mapToJson = (map) => {

        let obj = Object.create(null);

        for (let [key,value] of map) {

            if(value instanceof Array && key != 'Evidence')
            {
                // Only process arrays that contain Maps (subpages), not simple values
                if (value.length > 0 && value[0] instanceof Map)
                {
                    let sub_obj = [];

                    for (let sub_entry of value)
                    {
                        let entry = Object.create(null);

                        for (let [entry_key,entry_value] of sub_entry)
                        {
                            entry[entry_key] = entry_value;
                        }

                        sub_obj.push(entry);
                    }

                    obj[key] = sub_obj;
                }
                else
                {
                    // Simple array values (like multi-select) - keep as-is
                    obj[key] = value;
                }
            }
            else
            {
                obj[key] = value;
            }
        }
        
        return obj;

    };

    Vue.prototype.$formTools.activatedItems = activatedItems;

    Vue.prototype.$formTools.clearItemAndDescendants = clearItemAndDescendants;

    Vue.prototype.$formTools.findItemsByIdentifier = findItemsByIdentifier;

};

export default FormTools;
